import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import "../UserProfile/AccountSideBar/AccountSideBar.css";
import user from '../../../assets/img/my-user.png';
import axios from "axios";
import {RESOURCE_BASE_URL, WS_BASE_URL} from "../../../configuration";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import ContactUs from "../SiteRoot/Navigation/ContactUs/ContactUs";
let stompClient = null;

class QualitySideBar extends Component{
    constructor(props) {
        super(props);
        this.state = {
            userName : '',
            replyCount: 0,
            newInquiryCount:0,
            userId : this.props.user.id,
            isStompClientConnected : false
        };

        this.connectToNotification = this.connectToNotification.bind(this);
        this.onConnectedToNotification = this.onConnectedToNotification.bind(this);
        this.onNotificationReceived = this.onNotificationReceived.bind(this);
        this.onErrorToNotification = this.onErrorToNotification.bind(this);
        this.getInquiryAndComplaintCount = this.getInquiryAndComplaintCount.bind(this);
    }

    connectToNotification = () => {
        if (!this.state.isStompClientConnected) {

            const Stomp = require('stompjs');
            var SockJS = require('sockjs-client');
            SockJS = new SockJS(WS_BASE_URL + "ws");
            stompClient = Stomp.over(SockJS);
            stompClient.connect({}, this.onConnectedToNotification, this.onErrorToNotification);
        }
    };

    onConnectedToNotification = () => {

        this.setState({
            isStompClientConnected: true
        });
        clearInterval(this.state.intervalId);

        // Subscribing to notification
        stompClient.subscribe('/kitcut/notification', this.onNotificationReceived);

    };

    onNotificationReceived = (payload) => {
        let notificationPayload = JSON.parse(payload.body);

        if(notificationPayload.userId === this.state.userId){
            console.log("USER EQUALS ==============================");
            this.getInquiryAndComplaintCount();
            this.props.getUserComplaints();
        }
    };

    onErrorToNotification = (error) =>{
        this.connectToNotification();
    };

    componentDidMount() {
        this.getInquiryAndComplaintCount();
        this.connectToNotification();
    }

    getInquiryAndComplaintCount = () => {
        axios.get(RESOURCE_BASE_URL + 'api/inquiries/'+  InitialQuotationState.loggedUserId + '/new')
            .then((res) => {
                this.setState({
                    newInquiryCount:res.data
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

        axios.get(RESOURCE_BASE_URL +
            'api/quality-complaint/user/'+InitialQuotationState.loggedUserId+'/count/newReply')
            .then((res)=>{
                this.setState({
                    replyCount: res.data
                });
            })
    };

    showContactUs = () => {
        let elmnt = document.getElementById("sub-title-span-resp");

        if(elmnt !== null){
            elmnt.click();
        }
    };

    render() {
        return (
            <div className="container-fluid">
                <div className="spacer"></div>
                <div className="spacer"></div>

                <div>
                    <img className="user-img" alt=""
                         src={user}/> <span className="logged-user">
                    {this.props.user.username}
                </span>
                </div>
                <div className="user-profile-link side-content " id="user-profile-text-div">
                    <Link to="/profile">

                        <h4 className="light-txt">  <FormattedMessage id="app.user-profile.side-bar.my-account"
                                                                      defaultMessage='User Profile'
                                                                      description=''/></h4>

                    </Link>

                </div>
                <div className="user-profile-link side-content">
                    <Link to="/quotation/pcb">
                        <h4><span className="light-txt"><FormattedMessage id="app.user-profile.user-profile.side-bar.board-manufacturing-estimate"
                                                                          defaultMessage="Board Manufacturing Estimate"
                                                                          description=""
                        /></span></h4>
                    </Link>
                </div>
                <div className="user-profile-link side-content">
                    <h4><span className="light-txt" hidden={true}>
                            <ContactUs userId={this.props.userId}/>
                        </span>
                        <span className="inquiry-form" onClick={this.showContactUs}><FormattedMessage id="app.user-profile.user-profile.side-bar.inquiry"
                                                                                                      defaultMessage="Inquiry"
                                                                                                      description=""/>
                        </span>
                    </h4>
                </div>
                <div className="user-profile-link side-content">
                    <Link to="/order/all">
                        <h4 className="light-txt"><FormattedMessage id="app.user-profile.user-profile.side-bar.order-history"
                                                                    defaultMessage="Order History"
                                                                    description=""
                        /></h4>
                    </Link>
                </div>
                {/*<div className="user-profile-link side-content">*/}
                {/*<Link to="/order/last/">*/}
                {/*<h4 className="light-txt"><FormattedMessage id="app.user-profile.side-bar.last-order"*/}
                {/*defaultMessage="Last Order"*/}
                {/*description=""*/}
                {/*/></h4>*/}
                {/*</Link>*/}
                {/*</div>*/}
                <div className="user-profile-link side-content">
                    <Link to="/inquiry_list">
                        <h4 className="light-txt"><FormattedMessage id="app.user-profile.user-profile.side-bar.inquiries"
                                              defaultMessage="Inquiries"
                                              description=""
                        />
                            {this.state.newInquiryCount > 0 &&
                            <sup className="badge cart-item-count-badge">
                                {this.state.newInquiryCount}

                            </sup>
                            }
                        </h4>
                    </Link>
                </div>
                <div className="user-profile-link side-content">
                    <Link to="/complaint_list">
                        <h4><span className="order-history-text-deco"><FormattedMessage id="app.user-profile.user-profile.side-bar.complaints"
                                                                    defaultMessage="Quality Complaints"
                                                                    description=""
                        /></span>
                            {this.state.replyCount > 0 &&
                            <sup className="badge cart-item-count-badge">
                                {this.state.replyCount}
                            </sup>
                            }
                        </h4>
                    </Link>
                </div>
            </div>
        )
    }
}
export default QualitySideBar;



// WEBPACK FOOTER //
// ./src/components/Site/QualityComplaintNew/QualitySideBar.js